export const formatPrice = (price: { cents?: number }, locale: Locale, allowDecimals?: boolean): string => {
  if (price && price.cents) {
    return Intl
      ? new Intl.NumberFormat(locale, {
          currency: 'EUR',
          maximumFractionDigits: 2,
          style: 'currency',
        })
          .format(allowDecimals ? price.cents / 100 : Math.floor(price.cents / 100))
          .replace(/\D00(?=\D*$)/, '')
      : `${Math.floor(price.cents / 100)} €`
  }

  return ''
}
